import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { catchError, throwError } from 'rxjs'
import { MatSnackBar } from '@angular/material/snack-bar'
import { environment } from '../../../environments/environment'
import { Match } from '../models/match.model'

@Injectable({
  providedIn: 'root'
})
export class MatchService {

  constructor(private _snackBar: MatSnackBar, private fb:FormBuilder, private http: HttpClient) { }

  readonly baseURL = environment.DOMAIN_URL+'/api/matches/'
  readonly teamsURL = environment.DOMAIN_URL+'/api/teams/'

  list:Match[] = []

  matchForm = this.fb.group({
    _id : [''],
    season: ['2024/2025',Validators.required],
    date: [new Date(),Validators.required],
    round: ['',Validators.required],
    competition: ['',Validators.required],
    rival_name: ['',Validators.required],
    rival_nation: ['Spain',Validators.required],
    venue: ['',Validators.required],
    stadium: ['',Validators.required],
    coach: ['Diego Simeone',Validators.required],
    result: ['',Validators.required],
  })

  youtubeForm = this.fb.group({
    youtubeLink: ['',Validators.required]
  })
  
  fetchMatchList(){
    return this.http.get(this.baseURL)
    .pipe(catchError(this.errorHandler))
  }
  getMostRecentMatch(){
    return this.http.get(this.baseURL+'recent')
    .pipe(catchError(this.errorHandler))
  }
  fetchTeamsList(){
    return this.http.get(this.teamsURL)
    .pipe(catchError(this.errorHandler))
  }
  getCalendar(){
    return this.http.get(this.baseURL+'calendar')
    .pipe(catchError(this.errorHandler))
  }
  fetchSeasonMatchList(season:string){
    return this.http.post(this.baseURL+'seasonmatches', {season})
    .pipe(catchError(this.errorHandler))
  }

  getMatch(_id:string){
    return this.http.get<any>(this.baseURL+_id)
    .pipe(catchError(this.errorHandler))
  }

  postMatch(){
    this.matchForm.get('round')?.setValue('League Round '+this.matchForm.get('round')?.value)
    return this.http.post(this.baseURL, this.matchForm.value)
    .pipe(catchError(this.errorHandler))
  }

  putMatch(){
    this.matchForm.get('round')?.setValue('League Round '+this.matchForm.get('round')?.value)
    return this.http.put(this.baseURL+this.matchForm.get('_id')?.value, this.matchForm.value)
    .pipe(catchError(this.errorHandler))
  }

  deleteMatch(_id:string){
    return this.http.delete(this.baseURL+_id)
    .pipe(catchError(this.errorHandler))
  }

  patchYoutube(_id:string){
    return this.http.patch(this.baseURL+_id+'/youtube', {
      youtubeLink: this.youtubeForm.value.youtubeLink
    })
    .pipe(catchError(this.errorHandler))
  }
  
  private errorHandler(error: HttpErrorResponse) {
    if (error.status === 0) console.error('An error occurred:', error.error)
    else console.error(`Backend returned code ${error.status}, body was: `, error.error)
    return throwError(() => new Error('Something bad happened; please try again later.'))
  }
}
